import * as React from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, DiscoverPageModelState } from '@/models/connect';
import styles from './index.less';
import {
  OnClickLoadMoreBtnAction,
  OnUnmountMarketPageAction,
  OnMountMarketPageAction,
  OnChange_SelectedOperationCategoryIDs_Action,
  OnChange_FilterSelected_Action,
} from '@/models/discoverPage';
import FResourceCard from '@/components/FResourceCard';
import { Button } from 'antd';
import FNoDataTip from '@/components/FNoDataTip';
import { FUtil } from '@freelog/tools-lib';
import FLoadingTip from '@/components/FLoadingTip';
import * as AHooks from 'ahooks';
import FOperationCategoryFilter from '@/components/FOperationCategoryFilter';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FDropdown2 from '@/components/FDropdown2';

interface MarketProps {
  dispatch: Dispatch;
  discoverPage: DiscoverPageModelState;
}

function Market({ dispatch, discoverPage }: MarketProps) {
  const ref_Root = React.useRef<HTMLDivElement>(null);

  AHooks.useMount(() => {
    dispatch<OnMountMarketPageAction>({
      type: 'discoverPage/onMountMarketPage',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountMarketPageAction>({
      type: 'discoverPage/onUnmountMarketPage',
    });
  });

  return (
    <>
      <div ref={ref_Root}>
        <FOperationCategoryFilter
          value={discoverPage.selectedOperationCategoryIDs}
          onChange={(value) => {
            // console.log(value);
            dispatch<OnChange_SelectedOperationCategoryIDs_Action>({
              type: 'discoverPage/onChange_SelectedOperationCategoryIDs',
              payload: {
                value: value,
              },
            });
          }}
        />

        <div style={{ height: 30 }} />
        <div style={{ padding: '0 10px' }}>
          <FDropdown2
            autoArrow={true}
            getPopupContainer={() => ref_Root.current as HTMLElement}
            menu={{
              selectedKeys: [discoverPage.filterSelected],
              items: [
                {
                  key: '3,4,5',
                  label: '最新发布',
                },
                {
                  key: '5',
                  label: '编辑精选',
                },
              ],
              onClick: (value) => {
                dispatch<OnChange_FilterSelected_Action>({
                  type: 'discoverPage/onChange_FilterSelected',
                  payload: {
                    value: value.key as '3,4,5' | '5',
                  },
                });
              },
            }}
          >
            <span>{discoverPage.filterSelected === '3,4,5' ? '最新发布' : '编辑精选'}</span>
          </FDropdown2>
        </div>
      </div>

      {discoverPage.totalItem === -1 && (
        <FLoadingTip height={'calc(100vh - 70px - 140px - 80px - 52px - 52px - 100px)'} />
      )}

      {discoverPage.dataSource.length > 0 ? (
        <>
          <div style={{ height: 10 }} />
          <div className={styles.Content}>
            {discoverPage.dataSource.map((resource, j) => (
              <FResourceCard
                key={resource.id}
                resource={resource}
                // className={styles.FResourceCard}
                onClick={() => {
                  if (resource.collection) {
                    window.open(
                      FUtil.LinkTo.collectionDetails({
                        collectionID: resource.id,
                      }),
                    );
                  } else {
                    window.open(
                      FUtil.LinkTo.resourceDetails({
                        resourceID: resource.id,
                      }),
                    );
                  }
                }}
                // collection={{
                //   status: j % 2 === 0 ? 'finish' : 'unFinish',
                //   count: j,
                // }}
              />
            ))}
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
          </div>

          {discoverPage.totalItem > discoverPage.dataSource.length && (
            <>
              <div style={{ height: 100 }} />
              <div className={styles.bottom}>
                <Button
                  className={styles.loadMore}
                  onClick={() => {
                    dispatch<OnClickLoadMoreBtnAction>({
                      type: 'discoverPage/onClickLoadMoreBtn',
                    });
                  }}
                >
                  加载更多
                </Button>
              </div>
            </>
          )}
          <div style={{ height: 200 }} />
        </>
      ) : discoverPage.totalItem === 0 ? (
        <FNoDataTip height={'calc(100vh - 275px - 52px)'} tipText={'没有符合条件的资源'} />
      ) : null}
    </>
  );
}

export default connect(({ discoverPage }: ConnectState) => ({
  discoverPage: discoverPage,
}))(Market);

// interface Labels {
//   options: {
//     value: string;
//     text?: string;
//   }[];
//   value: string;
//   onChange?: (value: string) => void;
// }
//
// function Labels({ options, value, onChange }: Labels) {
//   return (
//     <div>
//       {options.map((i, j) => (
//         <a
//           key={i.value}
//           className={styles.filterTag + ' ' + (i.value === value ? styles.filterTagActive : '')}
//           onClick={() => onChange && onChange(i.value)}
//         >
//           {i.text || i.value}
//         </a>
//       ))}
//     </div>
//   );
// }
